<template>
	<ul class="step_nav">
		<li class="item" :class="{'active': index == 0}" style="top: -21px;"  @click="handleItemClick(0)">
			<i class="circle"></i>
			<i class="circle_big" ></i>
			<div class="name_wrap"><span class="name bg_theme">安装浏览器</span></div>
		</li>
		<li class="item" :class="{'active': index == 1}" style="top: 53px;" @click="handleItemClick(1)">
			<i class="circle"></i>
			<i class="circle_big"></i>
			<div class="name_wrap"><span class="name bg_theme">登录及注意事项</span></div>
		</li>
		<li class="item" :class="{'active': index == 2}" style="top: 127px;" @click="handleItemClick(2)">
			<i class="circle"></i>
			<i class="circle_big"></i>
			<div class="name_wrap"><span class="name bg_theme">康复阶段</span></div>
		</li>
		<li class="item" :class="{'active': index == 3}" style="top: 201px;" @click="handleItemClick(3)">
			<i class="circle"></i>
			<i class="circle_big"></i>
			<div class="name_wrap"><span class="name bg_theme">训练演示</span></div>
		</li>
		<li class="item" :class="{'active': index == 4}" style="top: 275px;" @click="handleItemClick(4)">
			<i class="circle"></i>
			<i class="circle_big"></i>
			<div class="name_wrap"><span class="name bg_theme">扫码关注小程序</span></div>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
			index: {
				type: Number,
				default: -1
			}
		}
	}
</script>

<style scoped>
	.step_nav{ position: fixed;z-index: 150;width: 1px;height: 296px;top: 50%;left: 30px;margin-top: -148px;background: #f1c73a;cursor: pointer; }
	.step_nav .item{ position: absolute;width: 42px;height: 42px;left: -20.5px; }
	.step_nav .circle{ display: block;position: absolute;z-index: 9;width: 20px;height: 20px;top: 11px;left: 11px;border-radius: 50%;background: #f1c73a; }
	.step_nav .circle_big{ display: block;position: absolute;z-index: 5;width: 42px;height: 42px;top: 0;left: 0;border-radius: 50%;background: #284cae;transform: scale(0, 0);transition: all .2s linear .3s; }
	.step_nav .active .circle_big{ transform: scale(1, 1);transition: all .2s linear; }
	.step_nav .item:hover .circle_big{ transform: scale(1, 1);transition: all .2s linear; }
	.step_nav .name_wrap{ display: block;position: absolute;width: 0px;height: 42px;top: 0;left: 21.5px;font-size: 18px;color: #fff;line-height: 42px;overflow: hidden;transition: all .2s linear; }
	.step_nav .active .name_wrap{ width: 208.5px;transition: all .2s linear .3s; }
	.step_nav .item:hover .name_wrap{ width: 208.5px;transition: all .2s linear .3s; }
	.step_nav .name{ display: block;width: 208.5px;height: 42px;padding: 0 0 0 30.5px;border-radius: 0 21px 21px 0;transform: translateX(-100%);transition: all .2s linear; }
	.step_nav .active .name{ transform: translateX(0);transition: all .2s linear .3s; }
	.step_nav .item:hover .name{ transform: translateX(0);transition: all .2s linear .3s; }
</style>
